export const nl2Br = (text: string) => text.replace(/\n/g, "<br />");

export const escapeHTML = (str: string) =>
  str.replace(
    /[&<>'"]/g,
    tag =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "'": "&#39;",
        '"': "&quot;",
      })[tag] || tag,
  );

export const unescapeHTML = (str: string) =>
  str.replace(
    /&amp;|&lt;|&gt;|&#39;|&quot;/g,
    tag =>
      ({
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&#39;": "'",
        "&quot;": '"',
      })[tag] || tag,
  );

export const simpleSlug = (str?: null | string) => str?.toLowerCase().replace(/[^a-z\d]+/g, "-");
